// Analytics tracking helper - fire-and-forget POST catre /api/analytics/track.
// Genereaza/persista guest_session_id in localStorage pentru utilizatorii fara cont.
// Sesiune 37: skip cand userul logat are rol=admin; pageview helper pentru rute publice.
import { API_URL } from '../utils/api';

const GUEST_KEY = 'oferte_guest_session_id';

function getGuestSessionId() {
  try {
    let id = localStorage.getItem(GUEST_KEY);
    if (!id) {
      id = 'g-' + (crypto?.randomUUID ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2)));
      localStorage.setItem(GUEST_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function getStoredUserRol() {
  // Citeste user-ul curent din localStorage / sessionStorage. Foloseste rol pentru a sari peste tracking admin.
  try {
    const raw = localStorage.getItem('oferte_user') || sessionStorage.getItem('oferte_user') || '';
    if (!raw) return null;
    const u = JSON.parse(raw);
    return (u && u.rol) ? String(u.rol).toLowerCase() : null;
  } catch {
    return null;
  }
}

function shouldSkip() {
  // Skip tracking pentru clickurile/pageview-urile admin.
  return getStoredUserRol() === 'admin';
}

function sendEvent(event_name, meta) {
  try {
    const token = localStorage.getItem('oferte_token') || sessionStorage.getItem('oferte_token') || '';
    const guest_session_id = getGuestSessionId();
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ event_name: String(event_name).slice(0, 100), meta, guest_session_id }),
      keepalive: true,
    }).catch(() => { /* ignore */ });
  } catch {
    // ignore
  }
}

export function trackClick(eventName, meta = {}) {
  if (!eventName) return;
  if (shouldSkip()) return;
  sendEvent(eventName, meta || {});
}

// Sesiune 103: dedup pageview - blocheaza acelasi path emis sub 1500ms (burst remount RouteTracker).
let _lastPageviewPath = null;
let _lastPageviewAt = 0;
export function trackPageview(path, extra = {}) {
  if (!path) return;
  if (shouldSkip()) return;
  const now = Date.now();
  if (path === _lastPageviewPath && (now - _lastPageviewAt) < 1500) return;
  _lastPageviewPath = path;
  _lastPageviewAt = now;
  // Captare automata UTM (utm_source, utm_campaign etc.) la prima vizita.
  let utm = {};
  try {
    const params = new URLSearchParams(window.location.search || '');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid'].forEach(k => {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 100);
    });
  } catch { /* ignore */ }
  sendEvent('pageview', { path, ...utm, ...extra });
}

export async function fetchTopClicks(interval = 'zi', limit = 20, userKey = '', source = 'all') {
  const token = localStorage.getItem('oferte_token') || sessionStorage.getItem('oferte_token') || '';
  const params = new URLSearchParams({ interval, limit: String(limit), source });
  if (userKey) params.set('user_id', userKey);
  const res = await fetch(`${API_URL}/api/analytics/top-clicks?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Eroare la incarcare statistici');
  return await res.json();
}
